/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PASS API
 * OpenAPI spec version: 3.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";

import { nmibleInstanceV3 } from "../../mutator/axios-instance-v3";

import type {
  DataResponseParticipantVisitScheduleResponse,
  DataResponseStudyArmsResponse,
  DataResponseVisitScheduleResponse,
  ErrorResponse,
  GetVisitScheduleVisitsGetParams,
  HTTPValidationError,
  StudyArmsUpdate,
} from "../../model";
import type { ErrorType, BodyType } from "../../mutator/axios-instance-v3";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Update Study Arms
 */
export const updateStudyArmsVisitsPut = (
  studyArmsUpdate: BodyType<StudyArmsUpdate>,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<DataResponseStudyArmsResponse>(
    {
      url: `/visits`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: studyArmsUpdate,
      signal,
    },
    options
  );
};

export const getUpdateStudyArmsVisitsPutMutationKey = () =>
  ["updateStudyArmsVisitsPut"] as const;

export const getUpdateStudyArmsVisitsPutMutationOptions = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStudyArmsVisitsPut>>,
    TError,
    UpdateStudyArmsVisitsPutMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateStudyArmsVisitsPut>>,
  TError,
  UpdateStudyArmsVisitsPutMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateStudyArmsVisitsPutMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateStudyArmsVisitsPut>>,
    UpdateStudyArmsVisitsPutMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return updateStudyArmsVisitsPut(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateStudyArmsVisitsPutMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateStudyArmsVisitsPut>>
>;
export type UpdateStudyArmsVisitsPutMutationBody = BodyType<StudyArmsUpdate>;
export type UpdateStudyArmsVisitsPutMutationError = ErrorType<
  ErrorResponse | HTTPValidationError
>;
export interface UpdateStudyArmsVisitsPutMutationVariables {
  data: BodyType<StudyArmsUpdate>;
}

/**
 * @summary Update Study Arms
 */
export const useUpdateStudyArmsVisitsPut = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateStudyArmsVisitsPut>>,
      TError,
      UpdateStudyArmsVisitsPutMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateStudyArmsVisitsPut>>,
  TError,
  UpdateStudyArmsVisitsPutMutationVariables,
  TContext
> => {
  return useMutation(
    getUpdateStudyArmsVisitsPutMutationOptions(options),
    queryClient
  );
};
/**
 * Get a participant's visit schedule with their Participant Visits, as
 * the participant app shows it.
 *
 * A participant gets their own. A User with Visits Read names the
 * participant with ``participant_id``.
 * @summary Get Visit Schedule
 */
export const getVisitScheduleVisitsGet = (
  params?: GetVisitScheduleVisitsGetParams,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<DataResponseVisitScheduleResponse>(
    { url: `/visits`, method: "GET", params, signal },
    options
  );
};

export const getGetVisitScheduleVisitsGetQueryKey = (
  params?: GetVisitScheduleVisitsGetParams
) => {
  return [`/visits`, ...(params ? [params] : [])] as const;
};

export const getGetVisitScheduleVisitsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getVisitScheduleVisitsGet>>,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  params?: GetVisitScheduleVisitsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVisitScheduleVisitsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetVisitScheduleVisitsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVisitScheduleVisitsGet>>
  > = ({ signal }) => getVisitScheduleVisitsGet(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getVisitScheduleVisitsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetVisitScheduleVisitsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVisitScheduleVisitsGet>>
>;
export type GetVisitScheduleVisitsGetQueryError = ErrorType<
  ErrorResponse | HTTPValidationError
>;

export function useGetVisitScheduleVisitsGet<
  TData = Awaited<ReturnType<typeof getVisitScheduleVisitsGet>>,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  params: undefined | GetVisitScheduleVisitsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVisitScheduleVisitsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitScheduleVisitsGet>>,
          TError,
          Awaited<ReturnType<typeof getVisitScheduleVisitsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetVisitScheduleVisitsGet<
  TData = Awaited<ReturnType<typeof getVisitScheduleVisitsGet>>,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  params?: GetVisitScheduleVisitsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVisitScheduleVisitsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitScheduleVisitsGet>>,
          TError,
          Awaited<ReturnType<typeof getVisitScheduleVisitsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetVisitScheduleVisitsGet<
  TData = Awaited<ReturnType<typeof getVisitScheduleVisitsGet>>,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  params?: GetVisitScheduleVisitsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVisitScheduleVisitsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Visit Schedule
 */

export function useGetVisitScheduleVisitsGet<
  TData = Awaited<ReturnType<typeof getVisitScheduleVisitsGet>>,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  params?: GetVisitScheduleVisitsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVisitScheduleVisitsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetVisitScheduleVisitsGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Get the visit schedule (arms + visits) for a study.
 * @summary Get Study Visit Schedule
 */
export const getStudyVisitScheduleVisitsStudyStudyIdGet = (
  studyId: string,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<DataResponseStudyArmsResponse>(
    { url: `/visits/study/${studyId}`, method: "GET", signal },
    options
  );
};

export const getGetStudyVisitScheduleVisitsStudyStudyIdGetQueryKey = (
  studyId: string
) => {
  return [`/visits/study/${studyId}`] as const;
};

export const getGetStudyVisitScheduleVisitsStudyStudyIdGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getStudyVisitScheduleVisitsStudyStudyIdGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  studyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudyVisitScheduleVisitsStudyStudyIdGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetStudyVisitScheduleVisitsStudyStudyIdGetQueryKey(studyId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStudyVisitScheduleVisitsStudyStudyIdGet>>
  > = ({ signal }) =>
    getStudyVisitScheduleVisitsStudyStudyIdGet(studyId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: studyId !== null && studyId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStudyVisitScheduleVisitsStudyStudyIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetStudyVisitScheduleVisitsStudyStudyIdGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStudyVisitScheduleVisitsStudyStudyIdGet>>
>;
export type GetStudyVisitScheduleVisitsStudyStudyIdGetQueryError = ErrorType<
  ErrorResponse | HTTPValidationError
>;

export function useGetStudyVisitScheduleVisitsStudyStudyIdGet<
  TData = Awaited<
    ReturnType<typeof getStudyVisitScheduleVisitsStudyStudyIdGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  studyId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudyVisitScheduleVisitsStudyStudyIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getStudyVisitScheduleVisitsStudyStudyIdGet>
          >,
          TError,
          Awaited<ReturnType<typeof getStudyVisitScheduleVisitsStudyStudyIdGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStudyVisitScheduleVisitsStudyStudyIdGet<
  TData = Awaited<
    ReturnType<typeof getStudyVisitScheduleVisitsStudyStudyIdGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  studyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudyVisitScheduleVisitsStudyStudyIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getStudyVisitScheduleVisitsStudyStudyIdGet>
          >,
          TError,
          Awaited<ReturnType<typeof getStudyVisitScheduleVisitsStudyStudyIdGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStudyVisitScheduleVisitsStudyStudyIdGet<
  TData = Awaited<
    ReturnType<typeof getStudyVisitScheduleVisitsStudyStudyIdGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  studyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudyVisitScheduleVisitsStudyStudyIdGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Study Visit Schedule
 */

export function useGetStudyVisitScheduleVisitsStudyStudyIdGet<
  TData = Awaited<
    ReturnType<typeof getStudyVisitScheduleVisitsStudyStudyIdGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  studyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudyVisitScheduleVisitsStudyStudyIdGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetStudyVisitScheduleVisitsStudyStudyIdGetQueryOptions(studyId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Get the visit schedule for a specific participant, including stipends for each visit.
 * @summary Get Visits For Participant
 */
export const getVisitsForParticipantParticipantsParticipantIdVisitsGet = (
  participantId: string,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<DataResponseParticipantVisitScheduleResponse>(
    { url: `/participants/${participantId}/visits`, method: "GET", signal },
    options
  );
};

export const getGetVisitsForParticipantParticipantsParticipantIdVisitsGetQueryKey =
  (participantId: string) => {
    return [`/participants/${participantId}/visits`] as const;
  };

export const getGetVisitsForParticipantParticipantsParticipantIdVisitsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getVisitsForParticipantParticipantsParticipantIdVisitsGet
      >
    >,
    TError = ErrorType<ErrorResponse | HTTPValidationError>,
  >(
    participantId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getVisitsForParticipantParticipantsParticipantIdVisitsGet
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof nmibleInstanceV3>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetVisitsForParticipantParticipantsParticipantIdVisitsGetQueryKey(
        participantId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getVisitsForParticipantParticipantsParticipantIdVisitsGet
        >
      >
    > = ({ signal }) =>
      getVisitsForParticipantParticipantsParticipantIdVisitsGet(
        participantId,
        requestOptions,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: participantId !== null && participantId !== undefined,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getVisitsForParticipantParticipantsParticipantIdVisitsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetVisitsForParticipantParticipantsParticipantIdVisitsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getVisitsForParticipantParticipantsParticipantIdVisitsGet
      >
    >
  >;
export type GetVisitsForParticipantParticipantsParticipantIdVisitsGetQueryError =
  ErrorType<ErrorResponse | HTTPValidationError>;

export function useGetVisitsForParticipantParticipantsParticipantIdVisitsGet<
  TData = Awaited<
    ReturnType<typeof getVisitsForParticipantParticipantsParticipantIdVisitsGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  participantId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getVisitsForParticipantParticipantsParticipantIdVisitsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getVisitsForParticipantParticipantsParticipantIdVisitsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getVisitsForParticipantParticipantsParticipantIdVisitsGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetVisitsForParticipantParticipantsParticipantIdVisitsGet<
  TData = Awaited<
    ReturnType<typeof getVisitsForParticipantParticipantsParticipantIdVisitsGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  participantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getVisitsForParticipantParticipantsParticipantIdVisitsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getVisitsForParticipantParticipantsParticipantIdVisitsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getVisitsForParticipantParticipantsParticipantIdVisitsGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetVisitsForParticipantParticipantsParticipantIdVisitsGet<
  TData = Awaited<
    ReturnType<typeof getVisitsForParticipantParticipantsParticipantIdVisitsGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  participantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getVisitsForParticipantParticipantsParticipantIdVisitsGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Visits For Participant
 */

export function useGetVisitsForParticipantParticipantsParticipantIdVisitsGet<
  TData = Awaited<
    ReturnType<typeof getVisitsForParticipantParticipantsParticipantIdVisitsGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  participantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getVisitsForParticipantParticipantsParticipantIdVisitsGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetVisitsForParticipantParticipantsParticipantIdVisitsGetQueryOptions(
      participantId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}
